module.exports = __webpack_public_path__ + "img/ps5dual.48db3a43.png";